import React from 'react';
import Item from '../item/Item';
import styles from './Header.module.scss';
import { Button } from 'primereact/button';

function Header({ indicador, modalIndicadorRef }) {
    return (
        <div className={`p-col-12 p-grid p-fluid ${styles.container}`}>
            <Item label="Código do indicador:" value={indicador?.codgIndicador} />
            <Item label="Nome do indicador:" value={indicador?.nmIndicador} col="5" />
            <div className={`${styles.button} p-col-3`}>
                <Button
                    label="Visualizar dados do indicador"
                    className="pi pi-eye p-button-outlined "
                    onClick={() => modalIndicadorRef.current?.show({ id: indicador?.id })}
                />
            </div>
        </div>
    );
}

export default Header;
